module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "placeholder fit-content"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "oekonomi.leverandoerer"
    }
  }), _vm._v("\n        Leverandører\n    ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description"
        }, [_vm._v("\n                    " + _vm._s(props.row.name) + "\n                ")]) : (props.column.field == 'total_quantity') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                    " + _vm._s(_vm._f("number")(props.row.total_quantity)) + "\n                ")]) : (props.column.field == 'total_cost') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                    " + _vm._s(_vm._f("currency")(props.row.total_cost)) + "\n                ")]) : (props.column.field == 'avg_price_per_material') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                    " + _vm._s(_vm._f("currency")(props.row.avg_price_per_material)) + "\n                ")]) : _c('div', [_vm._v("\n                    " + _vm._s(props.formattedRow[props.column.field]) + "\n                ")])]
      }
    }], null, false, 421130365)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                Ingen data ...\n            ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c3ec234"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/economy/components/suppliers.vue
// module id = 890
// module chunks = 0